import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { persistRulesSidebarOpenEpic } from './_epics/persistRulesSidebarOpen.epic';

export const rulesManagementEpic = safeCombineEpics(
  persistRulesSidebarOpenEpic,
);
